import {http} from '@/helpers/http-helper';

class QueryAnswerType {
    constructor(uuid, createdBy, createdAt, updatedBy, updatedAt, query, answer, categories, active) {
        this.uuid = uuid;
        this.createdBy = createdBy;
        this.createdAt = createdAt;
        this.updatedBy = updatedBy;
        this.updatedAt = updatedAt;
        this.query = query;
        this.answer = answer;
        this.categories = categories;
        this.active = active;
    }
}

export const getQueryAnswerTypes = () => {
    return new Promise( (resolve, reject) => {
        const url = 'queries/answer-types';
        http.get(url)
            .then((response) => {
                if (response.status === 200) {

                    let queryAnswerTypes = [];

                    response.data.forEach((queryAnswerType) => {
                        queryAnswerTypes.push(
                            new QueryAnswerType(
                                queryAnswerType.uuid,
                                queryAnswerType.createdBy.username,
                                new Date(queryAnswerType.createdAt),
                                queryAnswerType.updatedBy.username,
                                new Date(queryAnswerType.updatedAt),
                                queryAnswerType.query,
                                queryAnswerType.answer,
                                queryAnswerType.categories,
                                queryAnswerType.active)
                        );
                    });

                    resolve(queryAnswerTypes);
                }
                else {
                    reject(response.status);
                }
            })
            .catch((error) => {
                reject(error);
            });
    });
};

export const createQueryAnswerType = (newQueryAnswerType) => {
    return new Promise( (resolve, reject) => {
        const url = 'queries/answer-types';
        http.post(url, newQueryAnswerType)
            .then((response) => {
                if (response.status === 201) {
                    resolve(response.data);
                }
                else {
                    reject(response.status);
                }
            })
            .catch((error) => {
                reject(error);
            });
    });
};

export const updateQueryAnswerType = (queryAnswerType) => {
    return new Promise( (resolve, reject) => {
        const url = 'queries/answer-types/' + queryAnswerType.uuid;
        http.post(url, queryAnswerType)
            .then((response) => {
                if (response.status === 200) {
                    resolve(response.data);
                }
                else {
                    reject(response.status);
                }
            })
            .catch((error) => {
                reject(error);
            });
    });
};

export const getQueryAnswerType = (uuid) => {
    return new Promise( (resolve, reject) => {
        const url = 'queries/answer-types/' + uuid;
        http.get(url)
            .then((response) => {
                if (response.status === 200) {
                    let queryAnswerType = response.data;
                    resolve(new QueryAnswerType(
                        queryAnswerType.uuid,
                        queryAnswerType.createdBy.username,
                        new Date(queryAnswerType.createdAt),
                        queryAnswerType.updatedBy.username,
                        new Date(queryAnswerType.updatedAt),
                        queryAnswerType.query,
                        queryAnswerType.answer,
                        queryAnswerType.categories,
                        queryAnswerType.active));
                }
                else {
                    reject(response.status);
                }
            })
            .catch((error) => {
                reject(error);
            });
    });
};

export const deleteQueryAnswerType = (uuid) => {
    return new Promise( (resolve, reject) => {
        const url = 'queries/answer-types/' + uuid;
        http.delete(url)
            .then((response) => {
                if (response.status === 200) {
                    resolve(response.data);
                }
                else {
                    reject(response.status);
                }
            })
            .catch((error) => {
                reject(error);
            });
    });
};